import React from 'react'
import { Column } from 'src/components/Layout/Styled'
import InformationItem from './InformationItem'
import { Box, Typography } from '@mui/material'
import InfoIcon from '@mui/icons-material/Info'

const SingleForm = () => {
  return (
    <Column>
      <InformationItem index={0} />

      <Box
        sx={{
          mt: 3,
          px: 2,
          py: 1.5,
          border: '1px solid #00008F',
          borderRadius: '4px',
          backgroundColor: '#EDEDFD',
          display: 'flex',
          alignItems: 'flex-start',
          gap: 2,
          width: '100%',
          maxWidth: 330, // ให้จำกัดความกว้างไม่เกินนี้
          height: 'auto', // ปรับความสูงตามเนื้อหา
          flexWrap: 'wrap',
        }}
      >
        <InfoIcon
          sx={{
            color: '#EDEDFD',
            backgroundColor: '#00008F',
            borderRadius: '10px',
            fontSize: 20,
            mt: '2px',
          }}
        />
        <Typography
          variant="body2"
          sx={{
            color: '#00008F',
            whiteSpace: 'normal', // อนุญาตขึ้นบรรทัดใหม่
            wordBreak: 'break-word',
            flex: 1,
          }}
        >
          หากต้องการเปลี่ยนแปลงข้อมูลกรุณาติดต่อต้นสังกัด
        </Typography>
      </Box>
    </Column>
  )
}

export default SingleForm
